// extracted by mini-css-extract-plugin
module.exports = {"th-breadcrumb":"styles_th-breadcrumb__Z5IDf","th-breadcrumb-item":"styles_th-breadcrumb-item__KqPS_"};